// Use a non-null flag value here to override for local testing (see src/utils/featureFlagsAndMetrics::getFlagOverride)
export type FlagValue = string | boolean | number | null | undefined;

export const LD_FLAGS = {
  'agency-silkscreen': undefined,
  'curology-multi-rx-mild-acne-upsell': undefined,
  'curology-multi-rx': undefined,
  'curology-sunscreen-giveaway': undefined,
  'server-test-flag': undefined,
  'test-flag': undefined,
  shipping_fee_increase_agency: undefined,
  'shipping-fee-increase-test': undefined,
};

export type Flag = keyof typeof LD_FLAGS;
